import { gql } from "@apollo/client";

const CREATE_PLATFORM_SPORT = gql`
  mutation createPlateformSport($sport: Int!, $platformPublicId: String!) {
    createPlateformSport(
      createPlateformSportInput: { sport: $sport, platformPublicId: $platformPublicId }
    ) {
      id
    }
  }
`;
export default CREATE_PLATFORM_SPORT;
